module.exports = __webpack_public_path__ + "common/components/IconDS22/2187d92f3b38777fce106d9b51821f7c.svg";